
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({
  name: 'SuccessOpenStorePop'
})
export default class SuccessOpenStorePop extends Vue {
  showResult = false

  created() {}

  showPopup() {
    this.showResult = true
  }

  onCancel() {
    this.showResult = false
  }
}
